import React, { Component } from "react";
import Table from "./TableTransfer";
import SearchForm from "./SearchForm";

export default class Transfers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      transfers: [],
      searchConditions: {},
      lastPage: 1,
      currentPage: 1,
      removeDirectlyClick: 1,
      from: "",
      to: "",
      total: "",
    };
    this.handleSearch = this.handleSearch.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleRedirect = this.handleRedirect.bind(this);
    this.handleSort = this.handleSort.bind(this);
  }

  /**
   * Init data and form transfers or list transfers
   */
  componentWillMount() {
    const keySearch_str = this.props.location.search.substring(1);
    let keySearch_arr = { page: 1 };
    if (keySearch_str) {
      keySearch_arr = JSON.parse(
        '{"' +
          decodeURI(keySearch_str.replace(/&/g, '","'))
            .replace(/=/g, '":"')
            .replace("%3A", ":") +
          '"}'
      );
    }

    //always get list data
    axios
      .post("/api/transfer-request/search", keySearch_arr)
      .then((response) => {
        this.setState({
          transfers: response.data.data,
          lastPage: response.data.last_page,
          currentPage: response.data.current_page,
          searchConditions: keySearch_arr,
          from: response.data.from,
          to: response.data.to,
          total: response.data.total,
        });
        this.props.history.push({
          search: keySearch_str,
        });
      });
  }

  /**
   * Sort data
   */
  handleSort(key) {
    //add sort params to search conditions
    let newSearchConditions = this.state.searchConditions;
    newSearchConditions.sort_column = key.sort_column;
    newSearchConditions.sort_type = key.sort_type;
    this.setState({
      searchConditions: newSearchConditions,
    });
    axios
      .post("/api/transfer-request/search", newSearchConditions)
      .then((response) => {
        this.setState({
          transfers: response.data.data,
          lastPage: response.data.last_page,
          currentPage: response.data.current_page,
          searchConditions: newSearchConditions,
          from: response.data.from,
          to: response.data.to,
          total: response.data.total,
        });
        this.props.history.push({
          search: $.param(newSearchConditions),
        });
      });
  }

  /**
   * Get search data
   */
  handleSearch(key) {
    this.setState({
      searchConditions: key,
    });
    axios.post("/api/transfer-request/search", key).then((response) => {
      this.setState({
        transfers: response.data.data,
        lastPage: response.data.last_page,
        currentPage: response.data.current_page,
        from: response.data.from,
        to: response.data.to,
        total: response.data.total,
      });
      this.props.history.push({
        search: $.param(key),
      });
    });
  }

  /**
   * Edit transfer
   * staff: Object transfer
   */
  handleEdit(transfer) {
    this.props.history.push("/transfers/edit/" + transfer.id);
  }

  /**
   * Handle redirect
   */
  handleRedirect(e) {
    e.preventDefault();
    this.props.history.push(e.currentTarget.getAttribute("href"));
  }

  render() {
    const option = {
      4: { text: "振込済み", classHTML: "badge bg-yellow text-white" },
      1: { text: "振込中", classHTML: "badge bg-cyan text-white" },
      5: { text: "振込エラー", classHTML: "badge bg-pink text-white" },
    };

    const columns = [
      { name: "id", title: "ID", isSort: 1, type: "text" },
      {
        name: "tran_id",
        title: "取引ID",
        break_line: "text_break_line_header",
        type: "text_break_line",
      },
      {
        name: "first_last_name",
        title: "申請者",
        isSort: 1,
        type: "text",
        isSearch: true,
      },
      { name: "staffEmail", title: "メールアドレス", isSort: 1, type: "text" },
      {
        name: "transfer_amount",
        title: "申請額",
        isSort: 1,
        type: "convert_to_number",
        prefix: "¥",
      },
      {
        name: "transfer_fee",
        title: "手数料",
        isSort: 1,
        type: "convert_to_number",
        prefix: "¥",
      },
      {
        name: "rmtc",
        title: "振込額",
        isSort: 1,
        type: "convert_to_number",
        prefix: "¥",
      },
      {
        name: "status",
        title: "ステータス",
        isSort: 1,
        type: "option",
        option: option,
      },
      { name: "created_at", title: "申請日", isSort: 1, type: "date_time" },
      {
        name: "transfer_at",
        title: "振込日",
        isSort: 1,
        type: "date_time",
      },
      { name: "memo", title: "メモ", isSort: 0, type: "text" },
      {
        name: "action",
        title: "操作",
        isSort: 0,
        type: "action",
        elements: ["edit"],
        edit_except_ids: [],
      },
    ];
    return (
      <React.Fragment>
        <div className="row">
          <div className="col-sm-12">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a onClick={this.handleRedirect} href="/home">
                    ダッシュボード
                  </a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  銀行振込申請
                </li>
              </ol>
            </nav>
          </div>
        </div>

        <main id="main">
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="col">
                      <h4 className="mt-2 mb-0 page-title">銀行振込申請一覧</h4>
                    </div>
                    <div className="col text-right">
                      <button
                        className="btn btn-light btn-space"
                        type="button"
                        data-toggle="collapse"
                        data-target="#search-transfers"
                        aria-expanded="false"
                        aria-controls="search-transfers"
                      >
                        絞込検索
                      </button>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <SearchForm onSearch={this.handleSearch} />
                    </div>
                  </div>
                </div>
                <Table
                  onSearch={this.handleSearch}
                  onEdit={this.handleEdit}
                  header={columns}
                  data={this.state.transfers}
                  onSort={this.handleSort}
                  from={this.state.from}
                  to={this.state.to}
                  total={this.state.total}
                  myPagination={1}
                  searchConditions={this.state.searchConditions}
                  lastPage={this.state.lastPage}
                  currentPage={this.state.currentPage}
                  removeClick={this.state.removeDirectlyClick}
                />
              </div>
            </div>
          </div>
        </main>
      </React.Fragment>
    );
  }
}
